import React, { useEffect } from "react";
import Button from "components/Elements/Button/Button.js";
import Image from "components/Elements/Image/Image.tsx";
import Tooltip from "components/Elements/Tooltip/Tooltip.js";
import LoadingSaveForm from "./LoadingSaveForm.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import Icon from "components/Elements/Icon/Icon.tsx";
import { UserLoggedInSection } from "components/Reusable/UserNavigatorMenu/UserLoggedInSection.js";

const CreateFormHeader = ({
  settingsMode,
  changeOptionsMode,
  updateBeforeSave,
  previewFormFunction,
  saveDetails,
  hideSavedText,
  setUpdateBeforeSave,
  setShowModalUseBeforeUpload,
}) => {
  const { getTextByKey } = useContent();

  const clickOnSaveOrFinish = (redirect) => {
    if (redirect) {
      setShowModalUseBeforeUpload(false);
    }
    //after 0.5 second save details
    saveDetails(redirect);
  };

  return (
    <div className="create-form-header">
      <div className="header-settings">
        <ul>
          <li
            className={`${settingsMode === "form" ? "active" : ""} tour-form`}
            onClick={() => changeOptionsMode("form")}
          >
            <Tooltip
              id={"form-elements-tooltip"}
              tooltipTextKey="form-elements-tooltip"
              //hardPositioned
              bottom
            >
              <Image name="personal/poll" alt="" title="" ext="png" />
            </Tooltip>
          </li>
          <li
            className={`${
              settingsMode === "settings" ? "active" : ""
            } tour-settings`}
            onClick={() => changeOptionsMode("settings")}
          >
            <Tooltip
              id={"form-settings-option-tooltip"}
              tooltipTextKey="form-settings-option-tooltip"
              //hardPositioned
              bottom
            >
              <Image name="create-form/settings" alt="" title="" ext="png" />
            </Tooltip>
          </li>
          <li
            className={`${
              settingsMode === "publish" ? "active" : ""
            } tour-publish`}
            onClick={() => changeOptionsMode("publish")}
          >
            <Tooltip
              id={"form-publish-option-tooltip"}
              tooltipTextKey="form-publish-option-tooltip"
              //hardPositioned
              bottom
            >
              <Image
                name="create-form/integrate-icon"
                alt=""
                title=""
                ext="svg"
              />
            </Tooltip>
          </li>
        </ul>
      </div>
      <div className="header-title">
        <div className="form-title">
          <h1>{getTextByKey("edit-form-title")}</h1>
          <div className="saved-view">
            <LoadingSaveForm updateBeforeSave={updateBeforeSave} />
            <div
              className={`saved-form-container ${
                hideSavedText ? "hide-saved-text" : ""
              } ${updateBeforeSave.mode ? "hide-saved-text" : ""}`}
            >
              <span className="v-icon">
                <Icon name={"check"} />
              </span>
              <span className="saved-form-status">
                {getTextByKey("saved-form")}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="header-modes">
        <ul>
          <li
            onClick={() => previewFormFunction()}
            className="preview-tour-step"
          >
            <span>
              <Image name="create-form/preview-form" alt="" title="" />
            </span>
            <span>{getTextByKey("preview-form")}</span>
          </li>
          <li
            onClick={() => clickOnSaveOrFinish(false)}
            className="save-form-tour-step"
          >
            <Button>
              {" "}
              {/* <span>
                <Image src={saveFormImage} alt="" title="" />
              </span> */}
              <span>{getTextByKey("save")}</span>
            </Button>
          </li>
          <li
            onClick={() => clickOnSaveOrFinish(true)}
            className="finish-form-tour-step"
          >
            <Button>
              {" "}
              <span>
                <Image name="create-form/finish-icon" alt="" title="" />
              </span>
              <span>{getTextByKey("finish-form")}</span>
            </Button>
          </li>
          <li className="menu-user">
            <UserLoggedInSection isWhite={true} isCreateForm={true} />
          </li>
        </ul>
      </div>
    </div>
  );
};

export default CreateFormHeader;
